import React, { createContext, useContext } from 'react';

const BoardAiContext = createContext({
  hashtag: '',
  extensionId: null,
  onSaveSnapshot: null,
  openConversation: null,
  registerOpenConversation: null,
  openBoardChat: null,
  registerOpenBoardChat: null,
  startChatWithMessage: null,
  registerStartChatWithMessage: null,
  analyzePinAdded: null,
  enqueueDigestDelete: null,
});

export function BoardAiProvider({ children, value }) {
  return <BoardAiContext.Provider value={value}>{children}</BoardAiContext.Provider>;
}

export function useBoardAiContext() {
  return useContext(BoardAiContext);
}
